import gsap from "gsap"

export  class FooterFixed{
    hideContact(){
        document.querySelector('.c-footer-fixed ')
        gsap.to(".c-footer-fixed__contact", {
            y : 100,
            opacity:0,
            zIndex: 0
        })
    }

    showContact(){
        gsap.set(".c-footer-fixed__contact", {
            opacity:0,
            zIndex: 1,
            y: 100
        })

        gsap.to(".c-footer-fixed__contact", {
            opacity: 1, 
            y: 0,
            delay: 0.5, 
            duration : 1
        })

    }

    showAgainContact(){
        gsap.to(".c-footer-fixed__contact", {
            y: 0,
            opacity:1,
            zIndex: 1
        })
    }
    
}